import * as classnames from "classnames";

import { ApplicantChallenge, Msg } from "..";
import ApplicantExamModel from "../../models/ApplicantExam.model";

/**
 * Prop interface
 */
export interface ApplicantChallengeSetProps {
  challengeSetId: number;
  exam: ApplicantExamModel;
  tutorial?: boolean;
  className?: string;
}

/**
 * React Component
 */
export default function ApplicantChallengeSet({
  className,
  challengeSetId,
  exam,
  tutorial,
}: ApplicantChallengeSetProps) {
  const rootStyle = classnames("code-c-applicant-challenge-set", {
    [`${className}`]: Boolean(className),
  });
  const challengeSet = exam.getChallengeSetByChallengeSetId(challengeSetId);
  if (!challengeSet) {
    return null;
  }

  const challenges = challengeSet.challenges.map((item) => (
    <ApplicantChallenge
      key={item.id}
      challengeId={item.id}
      exam={exam}
      tutorial={tutorial}
    />
  ));

  const finished = challengeSet.challenges.filter((item) => {
    if (exam.isFinished()) {
      // Return exactly how many challenge they has solved
      return Boolean(exam.getResultByChallengeId(item.id).openedAt);
    } else {
      return exam.isChallengeFinished(item.id);
    }
  }).length;

  return (
    <div className={rootStyle}>
      <div className="code-c-applicant-challenge-set__container">
        <div className="code-c-applicant-challenge-set__header">
          <div>
            <span className="code-c-applicant-challenge-set__header-title">
              <Msg id="challenge.optional" />
            </span>
            <span>
              <Msg
                id={
                  challengeSet.numberChallengesToTake > 0
                    ? "challenge.optionalMessage1"
                    : "challenge.optionalMessage2"
                }
                values={{ number: challengeSet.numberChallengesToTake }}
              />
            </span>
          </div>
          <div>
            {challengeSet.numberChallengesToTake > 0 && (
              <span className="code-c-applicant-challenge-set__header-count">
                {finished}/{challengeSet.numberChallengesToTake}
              </span>
            )}
          </div>
        </div>
        <div>{challenges}</div>
      </div>
    </div>
  );
}
